import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { ErrorToast, SuccessToast } from 'services/toasterService';

export default function useAddDomian(cb) {
  const queryClient = useQueryClient();

  return useMutation(
    async (data) => {
      const response = await makeApiRequest.post(apiEndPoints.DOMAIN_API, data);
      return response?.data;
    },
    {
      onSuccess: (data) => {
        SuccessToast({ text: data.message });
        cb();
        queryClient.invalidateQueries('Domains-profile');
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
        queryClient.invalidateQueries('Domains-profile');
      },
    }
  );
}
